module.exports = __webpack_public_path__ + "img/test-cover-page.5354fdf5.svg";